<template>
  <div class="animated fadeIn">
    <b-tabs>
      <b-tab title="Contacts" no-body active>
        <!-- <div class="d-flex justify-content-end mb-2">
          <b-button variant="success" to="team/invite" class="mr-1">
            <i class="fal fa-paper-plane" />
          </b-button>
          <b-button variant="success" to="contacts/add">
            <i class="fal fa-plus" />
          </b-button>
        </div> -->

        <b-row>
          <b-col
            v-for="contact in contacts.models"
            :key="contact.id"
            cols="12"
            md="6"
          >
            <CustomerContactCard :contact="contact" />
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="Locations">
        <div class="d-flex justify-content-end mb-2">
          <b-button variant="success" to="locations/add">
            <i class="fal fa-plus" />
          </b-button>
        </div>

        <b-row>
          <b-col
            v-for="location in locations.models"
            :key="location.id"
            cols="12"
            md="6"
          >
            <CustomerLocationCard :location="location" />
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import CustomerContactCard from './CustomerContactCard.vue'
import CustomerLocationCard from './CustomerLocationCard.vue'

export default {
  name: 'CustomerDetailCardstack',
  components: {
    CustomerContactCard,
    CustomerLocationCard
  },
  props: {
    contacts: {
      type: Object,
      default: () => {}
    },
    locations: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
